import { COLORS } from './constants'
import { getFontSizes } from './themeUtils'

export const variables = {
  color: '#000',
  bgColor: COLORS.white,
  primaryColor: '#2d3394',
  secondaryColor: '#292a40',
}

export const fontSizes = getFontSizes()

export default {
  fontSizes,
}
